import React from 'react';
import classNames from 'classnames';

import AdaptiveImage from 'rebook/apps/utils/components/AdaptiveImage';

import styles from './style.scss';


const PromoCampaignBanner = ({ promoCampaign }) => {
  if (!promoCampaign || !promoCampaign.banner_mobile) {
    return null;
  }
  const style = {
    backgroundColor: `#${promoCampaign.banner_background_color}`,
  };
  return (
    <div className={classNames(styles.campaignContainer, 'jest-campaign-banner-container')} style={style}>
      <a href={promoCampaign.banner_link} className="jest-banner-link">
        <div className={styles.campaignBanner}>
          <AdaptiveImage
            className="jest-campaign-banner-link"
            src={{
              url: promoCampaign.banner_mobile,
              width: '320',
              height: '60',
            }}
            srcSet={{
              url: promoCampaign.banner_desktop,
              width: '960',
              height: '60',
            }}
            media="min-width: 960px" />
        </div>
      </a>
    </div>
  );
};

export default PromoCampaignBanner;
